import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, UntypedFormGroup } from '@angular/forms';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { CIPXQuoteRequestIntakeForm } from '../../../../intake-form.types';
import { isCIPXQuoteRequestIntakeFormStateBond, requiresCredit } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  standalone: true,
  imports: [SharedModule, SharedComponentsModule, NgxMaskDirective],
  selector: 'cipx-quote-request-intake-form-request-details-owners',
  templateUrl: 'owners.component.html',
  providers: [provideNgxMask()],
})
export class CIPXQuoteRequestIntakeFormRequestDetailsOwnersComponent
  implements OnInit {
  private _intakeFormService = inject(CIPXQuoteRequestIntakeFormService);

  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  requiresCredit = requiresCredit;
  isCIPXQuoteRequestIntakeFormStateBond = isCIPXQuoteRequestIntakeFormStateBond

  selectedStateBond = this._intakeFormService.selectedStateBond;

  ngOnInit() { }

  getSectionTitle(): string {
    if (this.quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 3) {
      return 'Bonded Individual';
    }

    return (
      'Business Owner' +
      ((this.quoteRequestForm.controls.requestDetails.controls.company_number_owners.value ?? 1) > 1 ? 's' : '')
    );
  }

  get requestDetailsGroup(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails;
  }

  /**
   * Returns the owners FormArray.
   */
  get owners(): FormArray {
    return this.quoteRequestForm.controls.requestDetails.controls.owners as FormArray;
  }

  getOwnerGroup(index: number): FormGroup {
    return this.owners.at(index) as FormGroup;
  }

}
